import MaterialTableHead, { TableHeadProps } from '@mui/material/TableHead';

export function TableHead(props: TableHeadProps) {
    return <MaterialTableHead data-testid={'TableHead-container'} {...props} />;
}

export default TableHead;
